import React from "react";
import {withTranslation} from "react-i18next";
import {Text, View} from "@react-pdf/renderer";

function CardBarrasPdf(props) {

    const {t, i18n, answers, stylesPdf, title, title2} = props;

    return (
        <View style={stylesPdf.rowheader}>
            {props.answers.filter(it => it.assessment !== null).map(item => {
                return (
                    <View key={item.id} style={{
                        flexDirection: "row",
                        padding: 3,
                        borderLeft: 1, borderLeftColor: '#FAFAFA', borderRight: 1, borderRightColor: '#FAFAFA'
                    }}>
                        <View style={stylesPdf.lineText}>
                            <View style={{width: "95%",  display: "flex", flexDirection: "row", flexWrap: "wrap", alignItems: "center"}}>
                                <Text style={{
                                    display: "flex",
                                    flexDirection: "row", flexWrap: "wrap",
                                    borderBottomRightRadius: 18,
                                    borderTopRightRadius: 18,
                                    minWidth: 172,
                                    fontStyle: 'normal',
                                    fontWeight: 400,
                                    fontSize: 10,
                                    paddingLeft: 10,
                                    paddingRight: 10,
                                    color: "#1C2E36",
                                    width: `${(item.points === 999 ? "70%" : (9 * item.points))}%`,
                                    backgroundColor:
                                        item.points >= 0 && item.points < 5 ? "#FFA39E" :
                                            item.points >= 5 && item.points < 8 ? "#FFD857" :
                                                (item.points === 999 || item.points === 99 ) ? "" : "#95DE64"
                                }}>{props.cervo  ? item.assessment.area.like : item.assessment.area.name} {
                                    (item.points === 999 || item.points === 99) &&
                                    <Text style={{fontWeight: 700}}>{t("indeciso")}</Text>}</Text>

                                {item.points !== 99 && <Text
                                    style={stylesPdf.strongText2}>&nbsp;{item.points === 999 ? "" : item.points}</Text>}
                            </View>
                        </View>
                    </View>)

            })}
            <View style={{
                flexDirection: "row",
                padding: 3,
                borderBottom: 1, borderBottomColor: '#FAFAFA',
                borderLeft: 1, borderLeftColor: '#FAFAFA', borderRight: 1, borderRightColor: '#FAFAFA'
            }}></View>
        </View>
    )
}

export default withTranslation()(CardBarrasPdf);
